"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, {});
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, {});
    }
    build(key) { return {}[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.get("/hff/queries/get_forms", { params });
    }
};
